module.exports = __webpack_public_path__ + "804bf87a58acd273ab7900bf54369b78.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/football.png
// module id = 1612
// module chunks = 0